import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

let state = {
    params: {
        platform: "",
        game_code: "",
        language: "",
        player_id: "",
        player_token: "",
        device_id: ""
    },
    landscape: null,
    isKeyboardOpen: false,
    securities: [],

    pageParent: "",
    pageTitle: "",
    isToolbarBackBtnShow: false,
    pageLoading: true,
    isRouting: false,
    authVerifiedType: ""
};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});
